// @ts-nocheck
const pt = {
  STUDENTS: 'alunos',
  CAN_ENROLL_TEMPORAL_ACCESS: 'Acesso temporário',
  CAN_ENROLL_FREEMIUM: 'Experimente agora',
  CAN_ENROLL_MEMBERSHIP: 'Acesso total',
  CAN_ENROLL_FREE: 'Grátis',
  CAN_ENROLL_PAID: 'Acesso total',
  CAN_ENROLL_B2B: '',
};

export default pt;
